export default {
  PREMIUM_RETOUCHING: 'PREMIUM_RETOUCHING',
  BASIC_RETOUCHING: 'BASIC_RETOUCHING',
  PERSONALIZATION: 'PERSONALIZATION',
  UNHANDLED: 'UNHANDLED',
  BACKGROUND: 'BACKGROUND',
  NOGO_TEMPLATE_NAME: 'Personalization_Prism_NOGO'
};
